import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToAnchor from './components/ScrollToAnchor';
import Home from './pages/Home';
import AboutPage from './pages/AboutPage';
import TeamPage from './pages/TeamPage';
import SearchPage from './pages/SearchPage';
import BrazilWatchPage from './pages/BrazilWatchPage';
import OrderPage from './pages/OrderPage';
import DeskPage from './pages/DeskPage';
import ClientPage from './pages/ClientPage';
import OpsPage from './pages/OpsPage';
import CommandPage from './pages/CommandPage';
import EntrarPage from './pages/EntrarPage';

function Shell() {
  const { pathname } = useLocation();
  const internal = ['/desk', '/ops', '/client', '/comando', '/entrar'].some((p) => pathname.startsWith(p));
  return (
    <div className="App">
      <ScrollToAnchor />
      {!internal && <Header />}
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/request-proposal" element={<SearchPage />} />
          <Route path="/brazil-watch" element={<BrazilWatchPage />} />
          <Route path="/order" element={<OrderPage />} />
          <Route path="/desk" element={<DeskPage />} />
          <Route path="/client" element={<ClientPage />} />
          <Route path="/ops" element={<OpsPage />} />
          <Route path="/comando" element={<CommandPage />} />
          <Route path="/entrar" element={<EntrarPage />} />
        </Routes>
      {!internal && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <Shell />
    </Router>
  );
}

export default App;
